import React from 'react';

import useStyles from './style';
import { Typography, Box, IconButton } from '@material-ui/core';
import HighlightOff from '@material-ui/icons/HighlightOff';


function ContentBox({ title, close, handleClose, children, ...props }) {
    const classes = useStyles()
    return (
        <Box className={classes.root} {...props}>
            <Box className={classes.header}>
                <Typography>{title}</Typography>
                {close && <IconButton style={{ padding: '0px', color: 'inherit' }} disableRipple onClick={handleClose}>
                    <HighlightOff />
                </IconButton>}
            </Box>
            <Box className={classes.content}>
                {children}
            </Box>
        </Box>
    )
}

export default ContentBox;